import React, { useState, useEffect } from 'react';
import { Button as SinkButton } from '@uncinc/uncinc-react-kitchen-sink';
import c from 'classnames';

import './style.scss';

const Button = ({ classes, children, secondary, black, white, icon = 'arrow', iconDown, size = 'small', href, forceBlank, ...props }) => {
  const [textColor, setTextColor] = useState(null);
  const [iconVariant, setIconVariant] = useState(4);

  useEffect(() => {
    if (secondary && !black && !white) {
      setIconVariant(2);
    } else if (secondary && black) {
      setTextColor('#000000');
      setIconVariant(3);
    } else if (secondary && white) {
      setTextColor('#FFFFFF');
      setIconVariant(4);
    }
  }, [secondary, black, white]);

  const classNames = c(
    `Button--${size}`,
    classes,
  );

  const iconClassNames = c(
    'icon-after',
    `icon-${icon}`,
    iconDown && 'icon-down',
    `icon-variant-${iconVariant}`,
  );

  return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    <SinkButton inverted={secondary} className={classNames} href={href} {...(forceBlank ? { target: '_blank' } : {})} {...props}>
      <div className="Button__wrapper">
        <div className={iconClassNames} style={{ color: textColor }}>
          { children }
          <div className="Button__underlayer" />
        </div>
      </div>
    </SinkButton>
  );
};

export default Button;
